import { cn } from "@lib/utils"

import { Button } from "@ui/button"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

interface ActionTooltipButtonProps {
    icon: React.ReactNode
    text?: string
    disabled?: boolean
    tooltip: string
    size?: "default" | "sm" | "lg" | "icon" | "xs"
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "icon"
    className?: string
    onClick?: () => void
}
export function ActionTooltipButton({ icon, text, disabled = false, tooltip, size = "default", variant = "default", className, onClick }: Readonly<ActionTooltipButtonProps>) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button onClick={onClick} variant={variant} size={size} disabled={disabled} className={cn(className)}>
                        {icon}
                        {text !== undefined && <span>{text}</span>}
                    </Button>
                </TooltipTrigger>
                <TooltipContent>
                    <p>{tooltip}</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
